export enum MapStyle {
  STREETS = "streets",
  SATELLITE = "satellite",
  DATA_VIZ = "dataviz",
  DATA_VIZ_LIGHT = "dataviz-light",
  DATA_VIZ_DARK = "dataviz-dark",
  HYBRID = "hybrid",
}

